var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgShieldLock1 = function SvgShieldLock1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shield-lock-1_svg__shield-lock-1_svg__clip0_4841_5741)",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.772 2a8 8 0 005.666 2 7.999 7.999 0 01-5.666 10A8 8 0 013.105 4a8 8 0 005.667-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.104 7.333a.667.667 0 101.334 0 .667.667 0 00-1.334 0zM8.771 8v1.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shield-lock-1_svg__shield-lock-1_svg__clip0_4841_5741"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.771)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgShieldLock1;